(function(){
  var modal = document.getElementById('sp-appt-modal');
  if (!modal) return;

  function openModal(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    modal.classList.add('is-open');
    document.body.classList.add('sp-appt-open');
    modal.setAttribute('aria-hidden', 'false');
  }
  function closeModal() {
    modal.classList.remove('is-open');
    document.body.classList.remove('sp-appt-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  // Single delegated click handler — captures BEFORE any other click handler
  // (jQuery / etc) gets a chance to navigate the browser away.
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest && e.target.closest('.book-an-appointment, .book_an_appointment_mobile_view, [data-sp-appt-open]');
    if (trigger) { openModal(e); return; }
  }, true);

  // Close handlers
  modal.querySelector('.sp-appt__x').addEventListener('click', closeModal);
  modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // Calendly — lazy-load on first CTA click
  var calLoaded = false;
  function ensureCalendly(cb) {
    if (calLoaded && window.Calendly) { cb && cb(); return; }
    calLoaded = true;
    var s = document.createElement('script');
    s.src = 'https://assets.calendly.com/assets/external/widget.js'; s.async = true;
    s.onload = function() { cb && cb(); };
    document.head.appendChild(s);
    var c = document.createElement('link');
    c.rel = 'stylesheet';
    c.href = 'https://assets.calendly.com/assets/external/widget.css';
    document.head.appendChild(c);
  }
  modal.querySelectorAll('[data-sp-appt-calendly]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      ensureCalendly(function() {
        if (window.Calendly && window.Calendly.initPopupWidget) {
          window.Calendly.initPopupWidget({ url: 'https://calendly.com/general-stienhardt/30min' });
          closeModal();
        }
      });
    });
  });
})();
